import { CustomerDashboardBIService } from "./CustomerDashboardBIService";

export const customerBiService = new CustomerDashboardBIService();